import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { request } from 'meinian-package/src/utils'
import * as userAuth from 'meinian-package/src/utils/auth'
import { targetCategory } from 'common'
import AssociateTaskModal from 'meinian-package/src/component//associateTaskModal'
import Icon from 'meinian-package/src/component/icon'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import ChooseStyleTaskModal from 'meinian-package/src/component/createIdeaMass/chooseStyleTask'
import styles from './index.module.less'

export default ({ style = null, auth, collectId, onInitTask, currentImage, setBanOperation }) => {
  const [modify, setModify] = useState(false)
  const [unfold, setUnfold] = useState(false)
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState([])
  const onDelete = (item) => {
    ModalConfirm.show({
      title: '删除关联任务',
      content: '是否删除该关联任务？',
      onOk: async () => {
        await request.post('/zhikuan/ins/blog/mission/blog-cancel-related-target', { collectId, targetIdList: [item.id] }).then(success => {
          success && setData(pre => pre.filter(it => it.id !== item.id))
          fetchData()
          onInitTask?.()
        })
      },
    })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    request.get('/zhikuan/ins/blog/mission/list-target-by-blog', { params: { collectId } }).then(result => {
      setData(result || [])
    })
  }
  const processEnum = {
    progress: '进行中',
    closed: '已结束',
    terminal: '已终止'
  }

  const _auth = userAuth.isPermissions(auth, ['FS17', 'FS17_CREATOR'])

  const [visibleTaskModal, setVisibleTaskModal] = useState(false)

  const onTaskModal = () => {
    setVisible(false)
  }

  useEffect(() => {
    if (visible || visibleTaskModal) {
      setBanOperation?.(true)
    } else {
      setBanOperation?.(false)
    }
  }, [visible, visibleTaskModal])

  return <div className={styles['image-detail-choose-style-task']} style={style}>
    <div className="choose-style-task-header">
      <div className="choose-style-task-header-left">
        <div className="title">选款任务</div>
        {
            !modify && _auth && <>
              <div className="choose-style-task-df-center" style={{ marginLeft: '8px' }} onClick={() => setVisible(true)}>
                <Icon type="m-lianjie" className="choose-style-task-icon" style={{ marginRight: '4px' }} />手动关联</div>
                {
                  !!data.length && <div className="choose-style-task-df-center" style={{ marginLeft: '8px' }} onClick={() => setModify(true)}>
                    <Icon type="m-bianji" className="choose-style-task-icon" style={{ marginRight: '4px' }} />修改</div>
                }
            </>
        }
      </div>
      <div>
        {
          modify ? <div className="choose-style-task-df-center" style={{ marginRight: '-8px' }} onClick={() => setModify(false)}>
            <Icon type="m-xiaoyan" className="choose-style-task-icon" style={{ marginRight: '4px' }} />完成
          </div> : data?.length > 3 && <div className="choose-style-task-df-center-unfold" style={{ marginRight: '-8px' }} onClick={() => setUnfold(!unfold)}>
            {!unfold ? '展开' : '收起'}<Icon type={`${!unfold ? 'm-Vxing_xia' : 'm-Vxing_shang'}`} />
          </div>
        }
      </div>
    </div>
    {
      data.length ? <div className={classNames('choose-style-task-list')} style={{ maxHeight: `${unfold ? data.length * 32 : 90}px` }}>
        {
        data.map(item => <div className="choose-style-task-list-item" key={item}>
          {modify && <div className="task-delete" onClick={() => onDelete(item)}><Icon type="m-jianshao_miaobian" className="task-delete-icon" /></div>}
          <div className="task-status">{processEnum[item.missionStatus]}</div>
          <div className="task-describe">{item.missionName}</div>
          <div className="task-category">{targetCategory(item.gender, item.rootCategory, item.category)}</div>
        </div>)
      }
      </div> : <div className="choose-style-task-list-empty">暂无关联任务</div>
    }
    {visible && <AssociateTaskModal
      type="associated"
      visible={visible}
      collectId={collectId}
      onOk={() => {
        fetchData()
        onInitTask?.()
        setVisible(false)
      }}
      onCreateTask={() => {
        setVisibleTaskModal(true)
      }}
      onClose={() => setVisible(false)}
    />}
    {
      visibleTaskModal && <ChooseStyleTaskModal
        visible={visibleTaskModal}
        taskItem={null}
        inspirationName={currentImage.name}
        inspirationId={currentImage.inspirationId}
        setVisible={setVisibleTaskModal}
        onOk={onTaskModal}
        onChange={undefined}
        onClose={undefined}
      />
    }
  </div>
}
